import { REQUEST_SCHEDULES_SUCCESS, REQUEST_SCHEDULES_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { ids: [], errors: null };

export default function schedules(state=INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_SCHEDULES_SUCCESS:
      return { ...state, ids: action.payload.data.map(data => data.id), errors: null }
    case REQUEST_SCHEDULES_FAILURE:
      return { ...state, ids: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
